import { render, staticRenderFns } from "./NotLoginHome.vue?vue&type=template&id=28a24f19&scoped=true"
import script from "./NotLoginHome.vue?vue&type=script&lang=js"
export * from "./NotLoginHome.vue?vue&type=script&lang=js"
import style0 from "./NotLoginHome.vue?vue&type=style&index=0&id=28a24f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a24f19",
  null
  
)

export default component.exports